import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  materialCategory: undefined,
  wallMaterial: undefined,
  density: undefined,
  thickness: undefined,
  thermalCoeff: undefined
};

const wallsCharacteristicsSlice = createSlice({
  name: 'wallsCharacteristics',
  initialState,
  reducers: {
    setMaterialCategory: (state, action) => {
      state.materialCategory = action.payload;
    },
    setWallMaterial: (state, action) => {
      state.wallMaterial = action.payload;
    },
    setDensity: (state, action) => {
      state.density = action.payload;
    },
    setThickness: (state, action) => {
      state.thickness = action.payload;
    },
    setThermalCoeff: (state, action) => {
      state.thermalCoeff = action.payload;
    },
    resetWallsCharacteristics: (state) => initialState,
  },
});

export const { setMaterialCategory, setWallMaterial, setDensity, setThickness, setThermalCoeff, resetWallsCharacteristics} = wallsCharacteristicsSlice.actions;

export default wallsCharacteristicsSlice.reducer;